var _style, _path, _defs, _mask, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs2, _clipPath, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegaFalBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "Layer_1",
    width: 284,
    height: 120,
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}.st3{fill:#1b3761}.st5{fill:#0778b5}.st10{fill:#19d3c5}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 0H268a12 12 0 0 1 12.1 12.1V108a12 12 0 0 1-12.1 12.1H12.1A12.2 12.2 0 0 1 0 107.9V12.1A12 12 0 0 1 12.1 0",
    className: "st0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    width: 330.2,
    height: 438,
    x: -49.2,
    y: -117,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_3_00000163032820773797897540000006165549906650608028_",
    width: 330.2,
    height: 438,
    x: -49.2,
    y: -117,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M267.9 0H12.1A12 12 0 0 0 0 12.1V108a12 12 0 0 0 12.1 12.1H268a12 12 0 0 0 12.1-12.1V12.1A12.2 12.2 0 0 0 267.9 0",
    filter: "url(#Adobe_OpacityMaskFilter)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_3_00000163032820773797897540000006165549906650608028_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.2-24 281 58v-82z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0778b5",
    d: "m236.5-24-41.4 41 22.3 22L281-24z",
    enableBackground: "new",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.2-24 41.4 41-22.3 22-63.7-63z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: -133.1,
    x2: 170.3,
    y1: -118.4,
    y2: 222.1,
    gradientTransform: "matrix(1 0 0 -1 0 120)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3f2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e3e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M-.4 321 166-97H-40.4z",
    enableBackground: "new",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144297411258221676380000012867949356162245783_",
    x1: -129.8,
    x2: 145.9,
    y1: -43.3,
    y2: 268.8,
    gradientTransform: "matrix(1 0 0 -1 0 120)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3f2f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e3e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cdcccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b4b4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000144297411258221676380000012867949356162245783_)",
    d: "m-49.2 261 185.7-378H-49.2z",
    enableBackground: "new",
    opacity: 0.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.5h52c2.5 0 4.5 2 4.5 4.5v52c0 2.5-2 4.5-4.5 4.5H27c-2.5 0-4.5-2-4.5-4.5V35c0-2.5 2-4.5 4.5-4.5",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#edeff0",
    d: "M27 30.5h52c2.5 0 4.5 2 4.5 4.5v52c0 2.5-2 4.5-4.5 4.5H27c-2.5 0-4.5-2-4.5-4.5V35c0-2.5 2-4.5 4.5-4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M28 36h50v50H28z",
    enableBackground: "new",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m182.3 54.3-13.9 12.8 6.4 5.9h-9.6V51.2l-4.3-4.6v30.3h24.6l4.3-3.9 6.4-5.9zm1.4 18.6h-2.8l-6.4-5.9 7.8-7.2 7.8 7.2zm-36.8 12.5-13.4-12.5h6.1l7.3 6.7 5-4.6V51.2l4.5-4.6v30z",
    className: "st3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m185.6 49-3.3-3-3.3 3 3.3 3zM122 70.9h2.7v-5.7h3l.6-.6h-3.6v-4.8h5.1l.6-.7H122zm11.6-12.4-5.3 12.4h1.6l1.5-3.5h5.2l1.5 3.5h.8zm-1.9 8.2 2.3-5.4 2.3 5.4zm11.7 3.6V59.2h-2.7v11.7h7.7v-.7h-5zm21 13.4v.9h-1.8c-1.4 0-2.4-.6-2.4-1.8 0-1.1.9-1.8 2.4-1.8h.1v-.3h1v3.1h.7zm-3.4-4.1c0-.3.2-.5.6-.5.3 0 .6.2.6.5s-.3.5-.6.5-.6-.2-.6-.5m1.7 4.1v-1.8h-.4c-.6 0-1.2.3-1.2.9s.5.9 1.1.9zm-.1-4.1c0-.3.2-.5.6-.5.3 0 .6.2.6.5s-.3.5-.6.5-.6-.2-.6-.5",
    className: "st5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.2 83.7h1.4v.9h-1.4z",
    className: "st5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 83.7h1.4v.9h-1.4z",
    className: "st5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M166.7 83.7h1.4v.9h-1.4z",
    className: "st5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M168 83.7h1.4v.9H168z",
    className: "st5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M169.2 83.7h1.4v.9h-1.4z",
    className: "st5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 83.7h.7V81h1v.3h2.2c.6 0 1.1.1 1.5.5.3.3.4.8.4 1.3v.6h.8v.9h-6.5v-.9zm1.6-1.6v1.5h3V83l-.2-.6c-.1-.1-.3-.3-.6-.3z",
    className: "st5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.8 83.7h1.4v.9h-1.4z",
    className: "st5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178 83.7h1.4v.9H178z",
    className: "st5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.3 83.7h1.4v.9h-1.4z",
    className: "st5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 83.7h2.9l.1-.9c0-.3-.1-.6-.3-.8s-.5-.2-.8-.2c-.4 0-.7.1-1 .3l-.4-.8c.5-.2 1-.4 1.6-.4a2 2 0 0 1 1.4.5c.4.3.6.9.6 1.5 0 .7-.2 1.4-.3 1.8h-3.7v-1zm1.3-3.9c0-.3.3-.5.6-.5s.6.2.6.5-.3.5-.6.5-.6-.2-.6-.5m3.4 6.1-.1-.9.5.1c.4 0 .5-.2.5-.6V81h1v3.4c0 1.2-.4 1.7-1.4 1.7z",
    className: "st5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M241.2 47.4 222.5 66l18.7 18.7L259.8 66zm0 33.4L226.4 66l14.8-14.8L255.9 66z",
    className: "st10"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d7cc9",
    d: "m252.1 58.3-5.8 5.8 1.9 1.9 3.9-3.9L256 66l-3.9 3.9-3.9-3.9-1.9 1.9 5.8 5.8 7.7-7.7zm-18.7-3.2 5.8 5.8 1.9-1.9-3.9-3.9 3.9-3.9 3.9 3.9-3.9 3.9 1.9 1.9 5.8-5.8-7.7-7.7zm-3.2 18.6 5.8-5.8-1.9-1.9-3.9 3.9-3.9-3.9 3.9-3.9 3.9 3.9 1.9-1.9-5.8-5.8-7.7 7.7zm18.7 3.2-5.8-5.8-1.9 1.9 3.9 3.9-3.9 3.9-3.9-3.9 3.9-3.9-1.9-1.9-5.8 5.8 7.7 7.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m244.4 66-3.2-3.2L238 66l3.2 3.2z",
    className: "st10"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c355e",
    d: "M262.3 64.6h3.9L242.5 41v3.9zm-19.8 22.5V91l23.6-23.6h-3.9zm-2.7 0L220 67.4h-3.9L239.8 91zm0-42.2V41l-23.6 23.6h3.9z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000011738924127876196200000000082183589628515968_",
    d: "M26.3 34h53.6v53.6H26.3z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038379831822397267410000016151931057522877114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000011738924127876196200000000082183589628515968_",
    overflow: "visible"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 45.8h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 56.4h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 75.7h1v1h-1zm.9-32.8h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 69.9h1v1h-1zm0 5.8h1v1h-1zm0 1h1v1h-1zm1-32.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 53.5h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 4.8h1v1h-1zm0 3.9h1v1h-1zm.9-33.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 48.7h1v1h-1zm0 3.9h1v1h-1zm0 5.8h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 59.3h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 69.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3 72.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm1-34.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 48.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 59.3h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 62.2h1v1h-1zm0 2.9h1v1h-1zm0 3.9h1v1h-1zm0 2.9h1v1h-1zm0 3.8h1v1h-1zm1-29.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 4.8h1v1h-1zm0 3.9h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 65.1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 69.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 72.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3 75.7h1v1h-1zm.9-32.8h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2 75.7h1v1h-1zm0 2h1v1h-1zm1-34.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 53.5h1v1h-1zm0 2.9h1v1h-1zm0 2h1v1h-1zm0 3.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 65.1h1v1h-1zm0 1.9h1v1h-1zm0 6.8h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2 75.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm1-41.5h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 40h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 51.6h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 59.3h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 62.2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 69.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 78.6h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm.9-49.2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 38.1h1v1h-1zm0 3.9h1v1h-1zm0 4.8h1v1h-1zm0 3.9h1v1h-1zm0 2.8h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 65.1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 67h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 72.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 75.7h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 78.6h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 81.5h1v1h-1zm0 1.9h1v1h-1zm1-45.3h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 42.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 5.7h1v1h-1zm0 1h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 62.2h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 69.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm1-45.3h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 40h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 45.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 48.7h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 59.3h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 65.1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 72.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 75.7h1v1h-1zm0 2.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1 81.5h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm.9-48.2h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 6.7h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56.4h1v1h-1zm0 2.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78.6h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm1-48.2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M40 38.1h1v1h-1zm0 4.8h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53.5h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56.4h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59.3h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40 62.2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 5.8h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M40 72.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75.7h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M40 83.4h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm1-50.2h1v1h-1zm0 5.8h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M41 45.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53.5h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78.6h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm.9-48.2h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9 42.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 4.8h1v1h-1zm0 2.9h1v1h-1zm0 5.8h1v1h-1zm0 2.9h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9 75.7h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9 83.4h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm1-50.2h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9 38.1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9 40h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9 45.8h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9 67h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9 75.7h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm.9-45.3h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 40h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 42.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 48.7h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 59.3h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 67h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm1-46.3h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 42.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 45.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 59.3h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 65.1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 3.9h1v1h-1zm1-41.5h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 51.6h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 56.4h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 65.1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 4.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 75.7h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 78.6h1v1h-1zm0 4.8h1v1h-1zm.9-46.2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7 38.1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7 65.1h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7 81.5h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm1-50.2h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7 38.1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 6.8h1v1h-1zm0 2.9h1v1h-1zm0 2.8h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7 78.6h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm1-50.2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 38.1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 40h1v1h-1zm0 1h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 45.8h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 53.5h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 65.1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 67h1v1h-1zm0 1h1v1h-1zm0 3.9h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7 78.6h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm.9-49.2h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 5.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6 56.4h1v1h-1zm0 2.9h1v1h-1zm0 2h1v1h-1zm0 4.8h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm1-46.3h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 40h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 42.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 59.3h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 62.2h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 78.6h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 81.5h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm1-46.3h1v1h-1zm0 3.8h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6 56.4h1v1h-1zm0 2h1v1h-1zm0 3.8h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6 67h1v1h-1zm0 4.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6 72.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6 75.7h1v1h-1zm0 2h1v1h-1zm0 3.8h1v1h-1zm0 3.9h1v1h-1zm.9-50.2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 38.1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 67h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 69.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 72.8h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 83.4h1v1h-1zm0 2h1v1h-1zm1-50.2h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 38.1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 48.7h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 65.1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 67h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 2h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm1-47.3h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 40h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 42.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 51.6h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 56.4h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 59.3h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 62.2h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 69.9h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 78.6h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 81.5h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm.9-49.2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 45.8h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 59.3h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 65.1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 75.7h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4 78.6h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm1-45.3h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 6.7h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 53.5h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 56.4h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 62.2h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 67h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 69.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4 83.4h1v1h-1zm0 2h1v1h-1zm.9-47.3h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 48.7h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 56.4h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 65.1h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 69.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 72.8h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.8h1v1h-1zm0 1h1v1h-1zm1-48.2h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 3.8h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 2.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3 69.9h1v1h-1zm0 3.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3 78.6h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm1-47.2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 38.1h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 7.7h1v1h-1zm0 4.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 72.8h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 81.5h1v1h-1zm0 1.9h1v1h-1zm.9-48.2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 40h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 42.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 48.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 51.6h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 59.3h1v1h-1zm0 6.8h1v1h-1zm0 1.9h1v1h-1zm0 5.8h1v1h-1zm0 1h1v1h-1zm0 5.8h1v1h-1zm0 1.9h1v1h-1zm1-47.3h1v1h-1zm0 1h1v1h-1zm0 9.6h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 3.8h1v1h-1zm0 4.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2 62.2h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2 67h1v1h-1zm0 3.9h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2 81.5h1v1h-1zm0 1h1v1h-1zm1-47.3h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2 38.1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 5.8h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2 59.3h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2 62.2h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2 67h1v1h-1zm0 2.9h1v1h-1zm0 3.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm.9-46.3h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 42.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 56.4h1v1h-1zm0 2.9h1v1h-1zm0 7.7h1v1h-1zm0 4.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 75.7h1v1h-1zm0 1h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 81.5h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1 83.4h1v1h-1zm1-48.2h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 38.1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 45.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 48.7h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 59.3h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 62.2h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1 67h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm1-47.3h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1 59.3h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 4.8h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1 81.5h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm.9-48.2h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M66 38.1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 11.6h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56.4h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M66 75.7h1v1h-1zm0 2h1v1h-1zm0 3.8h1v1h-1zm0 3.9h1v1h-1zm1-49.2h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51.6h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M67 67h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75.7h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78.6h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81.5h1v1h-1zm0 2.9h1v1h-1zm1-49.2h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 5.8h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M68 53.5h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65.1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm.9-49.2h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9 42.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9 56.4h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9 62.2h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm1-47.3h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 45.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 48.7h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 59.3h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 62.2h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 2.9h1v1h-1zm0 4.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 75.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 78.6h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 81.5h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9 83.4h1v1h-1zm1-40.5h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 5.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9 69.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9 75.7h1v1h-1zm0 2h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9 83.4h1v1h-1zm.9-39.5h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 48.7h1v1h-1zm0 2h1v1h-1zm0 2.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1zm0 2.8h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 69.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm1-39.6h1v1h-1zm0 9.7h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8 53.5h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8 56.4h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8 67h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8 75.7h1v1h-1zm0 2h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm.9-41.5h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 3.8h1v1h-1zm0 1h1v1h-1zm0 4.8h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 56.4h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 59.3h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 62.2h1v1h-1zm0 2h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 67h1v1h-1zm0 2.9h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 78.6h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 81.5h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm1-42.5h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7 48.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7 67h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7 75.7h1v1h-1zm0 2h1v1h-1zm0 4.8h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm1-41.5h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 51.6h1v1h-1zm0 5.8h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 2.8h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 72.8h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7 81.5h1v1h-1zm0 3.9h1v1h-1zm.9-42.5h1v1h-1zm0 2.9h1v1h-1zm0 1h1v1h-1zm0 3.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6 51.6h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 3.9h1v1h-1zm0 1.9h1v1h-1zm0 1.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6 69.9h1v1h-1zm0 2h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6 72.8h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6 75.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6 78.6h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6 83.4h1v1h-1zm0 2h1v1h-1zm1-38.6h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 48.7h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.8h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 59.3h1v1h-1zm0 4.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 65.1h1v1h-1zm0 1h1v1h-1zm0 1.9h1v1h-1zm0 1h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 69.9h1v1h-1zm0 1h1v1h-1zm0 1h1v1h-1zm0 2.9h1v1h-1z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 75.7h1v1h-1zm0 2h1v1h-1zm0 2.9h1v1h-1zm0 1.9h1v1h-1zM28.4 36.2h4.8V41h-4.8zm-.9 5.8h6.8v-6.8h-6.8z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 37.2h2.9v2.9h-2.9zm43.4-1h4.8V41h-4.8zm-1 5.8h6.8v-6.8h-6.8z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 37.2h2.9v2.9h-2.9zM28.4 80.6h4.8v4.8h-4.8zm-.9 5.7h6.8v-6.8h-6.8z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 81.5h2.9v2.9h-2.9z",
    clipPath: "url(#SVGID_00000038379831822397267410000016151931057522877114_)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegaFalBadge);
export default __webpack_public_path__ + "static/media/rega-fal-badge.1be70840990a5c40950f57acba1b6443.svg";
export { ForwardRef as ReactComponent };